import React from 'react';
import { useTranslation } from 'react-i18next';
import Responsive from 'react-responsive';
import { IMaster } from '@components-member/socialTrading/social.interfaces';
import ENUM_CONSTANTS from '@components-shared/enum.constants';
import { keyMap } from '@locales/lokalise/keyMap';
import { valueFromEnumService } from '@utils/library/getValueFromEnum.service';
import cn from 'classnames';
import { UserAvatar } from 'components/shared/userAvatar';
import { getAccentColorClass } from 'components/user/socialTrading/utils';
import styleVariables from 'styles/user/variables.scss';
import styles from './styles.module.scss';

interface renderContentBlockArgs {
  name: string;
  value: number | string;
  percentValue: boolean;
  needAccent: boolean;
}

export const OptionContent = (props: { option: IMaster }): JSX.Element => {
  const { i18n } = useTranslation();
  const { option } = props;
  const xsWidth = Number(styleVariables.xs.replace('px', ''));

  const renderContentBlock = (args: renderContentBlockArgs) => {
    const accentClass = getAccentColorClass(args.value);

    return (
      <div className={styles.content__container}>
        <span className={styles.content__property}>{args.name}</span>
        <span className={cn(styles.content__value, args.needAccent && accentClass)}>
          {args.value} {args.percentValue && '%'}
        </span>
      </div>
    );
  };

  return (
    <div className={styles.content}>
      <div className={styles.content__personality}>
        <UserAvatar withBorder={false} avatarSource={option.avatar} userInitials={option.initials} size={32} />
        <div className={styles.content__info}>
          <span className={styles.content__property}>{option.nickname} </span>
          <span className={styles.content__value}>{option.login} </span>
        </div>
      </div>
      <div className={styles.content__wrapper}>
        <Responsive minWidth={xsWidth}>
          {renderContentBlock({
            name: i18n.t(keyMap.commonPlatformType),
            value: valueFromEnumService.getValueFromEnumsWithI18n(
              option.tradingPlatformType,
              ENUM_CONSTANTS.TRADING_PLATFORM_TYPE,
              i18n,
            ),
            needAccent: true,
            percentValue: false,
          })}
        </Responsive>
        {renderContentBlock({
          name: i18n.t(keyMap.mastersFieldsProfitability),
          value: option.profitability,
          percentValue: true,
          needAccent: true,
        })}

        <Responsive minWidth={xsWidth}>
          {renderContentBlock({
            name: i18n.t(keyMap.investorsCount),
            value: option.countOfInvestors,
            percentValue: false,
            needAccent: false,
          })}
          {renderContentBlock({
            name: i18n.t(keyMap.mastersFieldsProfitSharing),
            value: option.profitSharing,
            percentValue: true,
            needAccent: false,
          })}
        </Responsive>
      </div>
    </div>
  );
};
